import {
    efServiceAssignmentTypes,
    ServiceAssignmentRentalCar,
    ServiceAssignmentVehicle,
    ServiceAssignmentAccommodation,
    ServiceAssignmentShortTrip,
    ServiceAssignmentReturnJourney,
    ServiceAssignmentSubstituteDriver,
    ServiceAssignmentMedicalClearance,
    ServiceAssignmentSickPerson,
    ServiceAssignmentVehicleReturn,
    ServiceAssignmentOtherServices,
    ServiceAssignmentPickup,
    ServiceAssignmentTrailerReturn,
    ServiceAssignmentDeathEventHelp,
    ServiceAssignmentMedicineShipment,
    ServiceAssignmentMedicalAdvice,
    ServiceAssignmentLegalAdvice,
} from '@ace-de/eua-entity-types';

const createNewServiceAssignment = assignmentType => {
    let newAssignment = {};

    switch (assignmentType) {
        case efServiceAssignmentTypes.VEHICLE: {
            newAssignment = new ServiceAssignmentVehicle();
            break;
        }

        case efServiceAssignmentTypes.RENTAL_CAR: {
            newAssignment = new ServiceAssignmentRentalCar();
            break;
        }

        case efServiceAssignmentTypes.ACCOMMODATION: {
            newAssignment = new ServiceAssignmentAccommodation();
            break;
        }

        case efServiceAssignmentTypes.SHORT_TRIP: {
            newAssignment = new ServiceAssignmentShortTrip();
            break;
        }

        case efServiceAssignmentTypes.RETURN_JOURNEY: {
            newAssignment = new ServiceAssignmentReturnJourney();
            break;
        }

        case efServiceAssignmentTypes.SUBSTITUTE_DRIVER: {
            newAssignment = new ServiceAssignmentSubstituteDriver();
            break;
        }

        case efServiceAssignmentTypes.MEDICAL_CLEARANCE: {
            newAssignment = new ServiceAssignmentMedicalClearance();
            break;
        }

        case efServiceAssignmentTypes.SICK_PERSON: {
            newAssignment = new ServiceAssignmentSickPerson();
            break;
        }

        case efServiceAssignmentTypes.VEHICLE_RETURN: {
            newAssignment = new ServiceAssignmentVehicleReturn();
            break;
        }

        case efServiceAssignmentTypes.OTHER_SERVICES: {
            newAssignment = new ServiceAssignmentOtherServices();
            break;
        }

        case efServiceAssignmentTypes.PICKUP: {
            newAssignment = new ServiceAssignmentPickup();
            break;
        }

        case efServiceAssignmentTypes.TRAILER_RETURN: {
            newAssignment = new ServiceAssignmentTrailerReturn();
            break;
        }

        case efServiceAssignmentTypes.DEATH: {
            newAssignment = new ServiceAssignmentDeathEventHelp();
            break;
        }

        case efServiceAssignmentTypes.MEDICINE_SHIPMENT: {
            newAssignment = new ServiceAssignmentMedicineShipment();
            break;
        }

        case efServiceAssignmentTypes.MEDICAL_ADVICE: {
            newAssignment = new ServiceAssignmentMedicalAdvice();
            break;
        }

        case efServiceAssignmentTypes.LEGAL_ADVICE: {
            newAssignment = new ServiceAssignmentLegalAdvice();
            break;
        }

        default:
            // no-op
    }
    return newAssignment;
};

export default createNewServiceAssignment;
